import React from 'react';

interface IAlertIcon {
  fillColor?: string;
}

const AlertIcon = ({ fillColor = 'var(--navi-color-red-dark)' }: IAlertIcon) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5679_160079)">
        <path
          d="M11.2716 1.49986C11.1517 1.26585 10.9695 1.06947 10.7452 0.932346C10.5209 0.795216 10.2631 0.722656 10.0001 0.722656C9.73722 0.722656 9.47939 0.795216 9.25506 0.932346C9.03073 1.06947 8.84859 1.26585 8.72872 1.49986L0.87157 17.2141C0.761985 17.4316 0.70981 17.6734 0.720002 17.9169C0.730193 18.1601 0.802413 18.3967 0.929803 18.6043C1.05719 18.8119 1.23552 18.9834 1.44786 19.1026C1.66019 19.2219 1.89948 19.2849 2.143 19.2856H17.8572C18.1008 19.2849 18.3401 19.2219 18.5524 19.1026C18.7648 18.9834 18.9431 18.8119 19.0705 18.6043C19.1978 18.3967 19.2701 18.1601 19.2802 17.9169C19.2905 17.6734 19.2382 17.4316 19.1287 17.2141L11.2716 1.49986Z"
          fill={fillColor}
        />
        <path
          d="M10 7.14258V11.7854"
          stroke="#FBD5D5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.0002 15.7143C9.80297 15.7143 9.64307 15.5544 9.64307 15.3571C9.64307 15.1599 9.80297 15 10.0002 15"
          stroke="#FBD5D5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 15.7143C10.1972 15.7143 10.3571 15.5544 10.3571 15.3571C10.3571 15.1599 10.1972 15 10 15"
          stroke="#FBD5D5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5679_160079">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AlertIcon;
